// JS custom

// Custom sort by dropdown in collection filters
window.bindCustomSortByEvent = function () {
  let customSortByFieldset = document.getElementById('CustomSortBy').querySelector('fieldset');
  customSortByFieldset.addEventListener('change', function (event) {
    if (event.target.matches('input')) {
      console.log('Input field changed:', event.target.value);
      let selectedValue = event.target.value;
      document.getElementById('SortBy').value = selectedValue;
      document.getElementById('FacetFiltersForm').dispatchEvent(new Event('input'));
    }
  });
};

/* Personalized word */
const CUSTOM_WORD_OPTION = 'mot-personnalise-1';
function customWordContainer() {
  return document.querySelector('.personalized-word-container.mot-personnalise');
}
function customWordInput() {
  return document.querySelector('#input-mot-personnalise');
}
function isCustomWordSelected() {
  return Boolean(document.querySelector(`.product-form__input.mot-personnalise input[data-input-option="${CUSTOM_WORD_OPTION}"]:checked`));
}
function setCustomWordError(visible) {
  const container = customWordContainer();
  const error = container?.querySelector('.personalized-word-error');
  const field = customWordInput();
  if (error) error.hidden = !visible;
  if (field) field.setAttribute('aria-invalid', visible ? 'true' : 'false');
  if (visible) field?.focus();
}
const CUSTOM_WORD_PROPERTY = 'properties[Mot personnalisé]';
function syncCustomWordProperty() {
  const selected = isCustomWordSelected();
  const value = selected ? (customWordInput()?.value || '').trim() : '';
  const includeProperty = selected && value !== '';
  document.querySelectorAll('input.personalized-word').forEach(elem => {
    elem.value = includeProperty ? value : '';
    elem.disabled = !includeProperty;
    if (includeProperty) {
      elem.name = CUSTOM_WORD_PROPERTY;
    } else {
      elem.removeAttribute('name');
    }
  });
}
function refreshCustomWordField() {
  const container = customWordContainer();
  if (!container) return;
  const selected = isCustomWordSelected();
  container.classList.toggle('is-unselected', !selected);
  if (!selected) setCustomWordError(false);
  syncCustomWordProperty();
}
document.addEventListener('change', event => {
  if (!event.target.matches?.('.product-form__input.mot-personnalise input[type="radio"]')) return;
  refreshCustomWordField();
});
document.addEventListener('input', event => {
  if (event.target?.id !== 'input-mot-personnalise') return;
  if (event.target.value.trim() !== '') setCustomWordError(false);
  syncCustomWordProperty();
});
document.addEventListener('submit', event => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  if (!form.querySelector('input.personalized-word')) return;
  refreshCustomWordField();
  if (!isCustomWordSelected()) return;
  if ((customWordInput()?.value || '').trim() !== '') return;
  event.preventDefault();
  event.stopImmediatePropagation();
  setCustomWordError(true);
}, true);
refreshCustomWordField();